// -------------------------------correct only page extra print when content over from half page -----------------------------------

// import React, { forwardRef } from "react";
// import { formatDateTime } from "../../Utils/Utils";

// const WATERMARK_TYPE = "both";

// /* ── One A4-page-tall watermark block ── */
// const PageWatermark = ({ status }) => {
//   const upper = (status || "SUMMARY").toUpperCase();

//   const BASE = 76;
//   const MAXC = 11;
//   const dfs =
//     upper.length > MAXC
//       ? Math.max(22, Math.floor(BASE * (MAXC / upper.length)))
//       : BASE;
//   const dls = upper.length > 12 ? 4 : 12;

//   return (
//     <div
//       style={{
//         width: "210mm",
//         height: "297mm",
//         position: "relative",
//         pointerEvents: "none",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         overflow: "hidden",
//       }}
//     >
//       {(WATERMARK_TYPE === "text" || WATERMARK_TYPE === "both") && (
//         <span
//           style={{
//             position: "absolute",
//             fontSize: `${dfs}px`,
//             fontWeight: 900,
//             letterSpacing: `${dls}px`,
//             textTransform: "uppercase",
//             transform: "rotate(-35deg)",
//             whiteSpace: "nowrap",
//             color: "rgba(80,80,100,0.14)",
//             userSelect: "none",
//             fontFamily: "Arial Black, Arial, sans-serif",
//           }}
//         >
//           {upper}
//         </span>
//       )}
//     </div>
//   );
// };

// const NewSummarySlip = forwardRef((props, ref) => {
//   const OrderDetails = props?.summarySlipData?.data
//     ? props?.summarySlipData?.data
//     : props?.generalInfo;

//   const Address = props?.generalInfo?.billingAddress
//     ? props?.generalInfo?.billingAddress
//     : [
//         props?.summarySlipData?.data?.address?.street,
//         props?.summarySlipData?.data?.address?.city,
//         props?.summarySlipData?.data?.address?.district,
//         props?.summarySlipData?.data?.address?.state,
//         props?.summarySlipData?.data?.address?.country,
//         props?.summarySlipData?.data?.address?.pincode,
//       ]
//         .filter(Boolean)
//         .join(", ");

//   const rawItems = Array.isArray(props?.summarySlipData?.data?.items)
//     ? props.summarySlipData.data.items
//     : Array.isArray(props?.summarySlipData)
//       ? props.summarySlipData
//       : [];

//   const filteredItems = props?.currentWarehouse
//     ? rawItems.filter((i) => i?.warehouseId === props?.currentWarehouse)
//     : rawItems;

//   const groupedData = filteredItems.reduce((acc, item) => {
//     const key = item?.collection_name || "COLLECTION NAME NOT FOUND";
//     if (!acc[key]) acc[key] = [];
//     acc[key].push(item);
//     return acc;
//   }, {});

//   const categoryData = Object.entries(groupedData).map(
//     ([collection_name, items]) => ({ name: collection_name, items }),
//   );

//   const grandTotals = filteredItems.reduce(
//     (acc, item) => {
//       const qty = Number(item?.qty) || 0;
//       const vm = Number(item?.vm) || 0;
//       const weight = Number(item?.weight) || 0;

//       acc.qty += qty;
//       acc.vm += vm * qty;
//       acc.weight += weight * qty;

//       return acc;
//     },
//     {
//       qty: 0,
//       vm: 0,
//       weight: 0,
//     },
//   );

//   const statusColor = "#000";
//   const payStatus = OrderDetails?.paymentStatus || "SUMMARY";

//   const ROWS_PER_PAGE = 28;
//   const totalRows = filteredItems.length + categoryData.length * 2 + 4;
//   const pageCount = Math.max(1, Math.ceil(totalRows / ROWS_PER_PAGE));

//   const S = {
//     th: {
//       padding: "6px 7px",
//       fontWeight: 700,
//       fontSize: "11px",
//       textAlign: "left",
//       background: "#fff",
//       color: "#000",
//       // border: "1px solid #000",
//       borderTop: "1px solid #000",
//       borderBottom: "1px solid #000",
//       borderLeft: "none",
//       borderRight: "none",
//     },
//     catHdr: {
//       padding: "5px 7px 3px",
//       fontWeight: 700,
//       fontSize: "12px",
//       // borderTop: "1.5px solid #000",
//       // borderBottom: "none",
//       // borderLeft: "none",
//       // borderRight: "none",
//       borderTop: "1px solid #000",
//       borderBottom: "1px solid #000",
//       borderLeft: "none",
//       borderRight: "none",
//       background: "#fff",
//     },
//     item: {
//       padding: "2px 7px",
//       border: "none",
//       verticalAlign: "middle",
//       lineHeight: 1.4,
//     },
//     total: {
//       padding: "4px 7px",
//       // fontWeight: 700,
//       borderTop: "1px solid #000",
//       borderBottom: "1px solid #000",
//       borderLeft: "none",
//       borderRight: "none",
//       background: "#fff",
//     },
//   };
//   const COL = {
//     sno: "8%",
//     name: "22%",
//     item: "15%",
//     desc: "26%",
//     qty: "13%",
//     wh: "16%",
//   };

//   return (
//     <div
//       ref={ref}
//       style={{
//         position: "relative",
//         width: "210mm",
//         background: "#fff",
//         fontFamily: "Arial, sans-serif",
//         fontSize: "12px",
//         color: "#000",
//       }}
//     >
//       {/* ── PRINT + WATERMARK STYLES ── */}
//       <style>{`
//         @media print {
//           @page {
//             size: A4;
//             margin: 8mm;
//           }
//           /* Force background graphics to print */
//           * {
//             -webkit-print-color-adjust: exact !important;
//             print-color-adjust: exact !important;
//           }
//         }

//         /* Watermark stacking column */
//         .ss-wm-col {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           pointer-events: none;
//           z-index: 111;
//         }

//         /* Content body sits above watermark */
//         .ss-body {
//           position: relative;
//           z-index: 1;
//           padding: 10mm 12mm 14mm;
//           background: transparent;
//         }
//       `}</style>

//       {/* ── WATERMARK COLUMN ── */}
//       <div className="ss-wm-col">
//         {Array.from({ length: pageCount }).map((_, i) => (
//           <PageWatermark key={i} status={payStatus} />
//         ))}
//       </div>

//       {/* ── CONTENT BODY ── */}
//       <div className="ss-body">
//         {/* Title */}
//         <div
//           style={{
//             textAlign: "center",
//             fontSize: "16px",
//             fontWeight: 700,
//             textDecoration: "underline",
//             marginBottom: "12px",
//           }}
//         >
//           {props?.currentWarehouseName ? "SUMMARY" : "MASTER SUMMARY"}
//         </div>

//         {props?.currentWarehouseName && (
//           <div
//             style={{
//               textAlign: "center",
//               fontSize: "12px",
//               marginBottom: "10px",
//             }}
//           >
//             Warehouse: <strong>{props.currentWarehouseName}</strong>
//           </div>
//         )}

//         {/* Info header */}
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "flex-start",
//             marginBottom: "12px",
//             fontSize: "11.5px",
//           }}
//         >
//           <div>
//             <div
//               style={{ fontWeight: 700, fontSize: "13px", marginBottom: "3px" }}
//             >
//               {OrderDetails?.name || OrderDetails?.dealerName}
//               {OrderDetails?.storeName ? ` / ${OrderDetails.storeName}` : ""}
//             </div>
//             <div style={{ color: "#000", lineHeight: 1.5 }}>{Address}</div>
//           </div>
//           <div style={{ textAlign: "right", lineHeight: 1.9, color: "#000" }}>
//             <div>
//               Date &amp; Time:{" "}
//               <strong>{formatDateTime(OrderDetails?.orderDate)}</strong>
//             </div>
//             <div>
//               Order ID: <strong>{OrderDetails?.orderId || "—"}</strong>
//             </div>
//             <div>
//               Payment Status:{" "}
//               <strong style={{ color: statusColor }}>
//                 {OrderDetails?.paymentStatus || "—"}
//               </strong>
//             </div>
//           </div>
//         </div>

//         {/* Main table */}
//         <table
//           style={{
//             width: "100%",
//             borderCollapse: "collapse",
//             tableLayout: "fixed",
//             fontSize: "11.5px",
//             // border: "1.5px solid #000",
//           }}
//         >
//           <colgroup>
//             <col style={{ width: COL.sno }} />
//             <col style={{ width: COL.name }} />
//             <col style={{ width: COL.item }} />
//             <col style={{ width: COL.desc }} />
//             <col style={{ width: COL.qty }} />
//             <col style={{ width: COL.wh }} />
//           </colgroup>
//           <thead>
//             <tr>
//               <td style={S.th}>S.No</td>
//               <td style={S.th}>Collection Name</td>
//               <td style={S.th}>Item No.</td>
//               <td style={S.th}>Description</td>
//               <td style={S.th}>Qty</td>
//               <td style={S.th}>Warehouse</td>
//             </tr>
//           </thead>
//           <tbody>
//             {categoryData.map((cat, ci) => {
//               const catQty = cat.items.reduce(
//                 (s, i) => s + (Number(i?.qty) || 0),
//                 0,
//               );
//               const catVm = cat.items.reduce(
//                 (s, i) => s + (Number(i?.vm) || 0) * (Number(i?.qty) || 0),
//                 0,
//               );

//               const catWeight = cat.items.reduce(
//                 (s, i) => s + (Number(i?.weight) || 0) * (Number(i?.qty) || 0),
//                 0,
//               );
//               return (
//                 <React.Fragment key={ci}>
//                   <tr>
//                     <td colSpan={6} style={S.catHdr}>
//                       {ci + 1}&nbsp;&nbsp;&nbsp;{cat.name}
//                     </td>
//                   </tr>
//                   {cat.items.map((item, idx) => (
//                     <tr key={idx}>
//                       <td
//                         style={{
//                           ...S.item,
//                           textAlign: "center",
//                           fontSize: "11px",
//                         }}
//                       >
//                         {idx + 1}
//                       </td>
//                       <td style={S.item}>
//                         <em>{cat.name}</em>
//                       </td>
//                       <td style={S.item}>{item?.itemNo || ""}</td>
//                       <td
//                         style={{
//                           ...S.item,
//                           fontSize: "10.5px",
//                           fontStyle: "italic",
//                         }}
//                       >
//                         {item?.desc || (
//                           <span style={{ fontStyle: "normal" }}></span>
//                         )}
//                       </td>
//                       <td style={S.item}>
//                         {item?.qty || 0} {item?.unit || ""}
//                       </td>
//                       <td style={S.item}>{item?.warehouse || ""}</td>
//                     </tr>
//                   ))}
//                   <tr>
//                     <td colSpan={2} style={S.total}>
//                       <strong>TOTAL</strong>
//                     </td>
//                     <td style={S.total}>
//                       CBM : <strong>{catVm.toFixed(3)}</strong>
//                     </td>
//                     <td style={S.total}>
//                       Weight : <strong>{catWeight.toFixed(3)} Kg</strong>
//                     </td>
//                     <td style={S.total}>
//                       Qty : <strong>{catQty}</strong>
//                     </td>
//                     <td style={S.total}></td>
//                   </tr>
//                 </React.Fragment>
//               );
//             })}
//             <tr>
//               <td colSpan={2} style={S.total}>
//                 <strong>GRAND TOTAL</strong>
//               </td>
//               <td style={S.total}>
//                 CBM : <strong>{grandTotals.vm.toFixed(3)}</strong>
//               </td>

//               <td style={S.total}>
//                 Weight : <strong>{grandTotals.weight.toFixed(3)} Kg</strong>
//               </td>

//               <td style={S.total}>
//                 Qty : <strong>{grandTotals.qty}</strong>
//               </td>
//               <td style={S.total}></td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// });

// export default NewSummarySlip;

// -------------------------- Extra Page Fix and desc alignment ------------------------------

import React, { forwardRef } from "react";
import { formatDateTime } from "../../Utils/Utils";

/*
 * HOW THE WATERMARK WORKS
 * -----------------------
 * We render a <div class="ss-wm-fixed"> that is:
 *   - position: fixed  (screen)  → covers the full viewport always
 *   - position: fixed  (print)   → the print engine repeats fixed elements
 *                                  on EVERY page automatically
 *
 * The watermark text is an inline SVG data-URI set as background-image
 * with background-size: 210mm 297mm and background-repeat: repeat so
 * one watermark tile appears centred on every A4 page.
 *
 * This approach needs ZERO height estimation or ResizeObserver — the
 * browser/print engine handles repetition natively.
 *
 * The content (.ss-body) has z-index:1 so it renders above the watermark.
 * pointer-events:none on the watermark div means it never intercepts clicks.
 */

const NewSummarySlip = forwardRef((props, ref) => {
  const OrderDetails = props?.summarySlipData?.data
    ? props?.summarySlipData?.data
    : props?.generalInfo;

  const Address = props?.generalInfo?.billingAddress
    ? props?.generalInfo?.billingAddress
    : [
        props?.summarySlipData?.data?.address?.street,
        props?.summarySlipData?.data?.address?.city,
        props?.summarySlipData?.data?.address?.district,
        props?.summarySlipData?.data?.address?.state,
        props?.summarySlipData?.data?.address?.country,
        props?.summarySlipData?.data?.address?.pincode,
      ]
        .filter(Boolean)
        .join(", ");

  const rawItems = Array.isArray(props?.summarySlipData?.data?.items)
    ? props.summarySlipData.data.items
    : Array.isArray(props?.summarySlipData)
      ? props.summarySlipData
      : [];

  const filteredItems = props?.currentWarehouse
    ? rawItems.filter((i) => i?.warehouseId === props?.currentWarehouse)
    : rawItems;

  const groupedData = filteredItems.reduce((acc, item) => {
    const key = item?.collection_name || "COLLECTION NAME NOT FOUND";
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});

  const categoryData = Object.entries(groupedData).map(
    ([collection_name, items]) => ({ name: collection_name, items }),
  );

  const grandTotals = filteredItems.reduce(
    (acc, item) => {
      const qty = Number(item?.qty) || 0;
      const vm = Number(item?.vm) || 0;
      const weight = Number(item?.weight) || 0;
      acc.qty += qty;
      acc.vm += vm * qty;
      acc.weight += weight * qty;
      return acc;
    },
    { qty: 0, vm: 0, weight: 0 },
  );

  const statusColor = "#000";
  const payStatus = (OrderDetails?.paymentStatus || "SUMMARY").toUpperCase();

  // Watermark text sizing
  const BASE = 76;
  const MAXC = 11;
  const dfs =
    payStatus.length > MAXC
      ? Math.max(22, Math.floor(BASE * (MAXC / payStatus.length)))
      : BASE;
  const dls = payStatus.length > 12 ? 4 : 12;

  // Build SVG data-URI entirely in JS — variables interpolate correctly
  const wmSvg = `data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="794" height="1123">` +
      `<text x="397" y="561" dominant-baseline="middle" text-anchor="middle" ` +
      `font-family="Arial Black,Arial,sans-serif" font-weight="900" ` +
      `font-size="${dfs}px" letter-spacing="${dls}px" ` +
      `fill="rgba(80,80,100,0.14)" ` +
      `transform="rotate(-35,397,561)">${payStatus}</text></svg>`,
  )}`;

  const S = {
    th: {
      padding: "6px 7px",
      fontWeight: 700,
      fontSize: "11px",
      textAlign: "left",
      background: "#fff",
      color: "#000",
      borderTop: "1px solid #000",
      borderBottom: "1px solid #000",
      borderLeft: "none",
      borderRight: "none",
    },
    catHdr: {
      padding: "5px 7px 3px",
      fontWeight: 700,
      fontSize: "12px",
      borderTop: "1px solid #000",
      borderBottom: "1px solid #000",
      borderLeft: "none",
      borderRight: "none",
      background: "#fff",
    },
    item: {
      padding: "2px 7px",
      border: "none",
      verticalAlign: "middle",
      lineHeight: 1.4,
    },
    itemDesc: {
      padding: "2px 7px",
      border: "none",
      verticalAlign: "top", // desc cell anchors to top; its height drives the row
      lineHeight: 1.4,
      fontSize: "10.5px",
      fontStyle: "italic",
      wordBreak: "break-word",
      whiteSpace: "normal",
    },
    total: {
      padding: "4px 7px",
      borderTop: "1px solid #000",
      borderBottom: "1px solid #000",
      borderLeft: "none",
      borderRight: "none",
      background: "#fff",
    },
  };

  const COL = {
    sno: "8%",
    name: "22%",
    item: "15%",
    desc: "26%",
    qty: "13%",
    wh: "16%",
  };

  return (
    <div
      ref={ref}
      style={{
        position: "relative",
        width: "210mm",
        background: "#fff",
        fontFamily: "Arial, sans-serif",
        fontSize: "12px",
        color: "#000",
      }}
    >
      <style>{`
        @media print {
          @page { size: A4; margin: 8mm; }
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
        }

        /*
         * WATERMARK OVERLAY
         * position:fixed makes the browser repeat this element on every
         * printed page automatically — no page-count math needed at all.
         * On screen it covers the viewport (harmless, pointer-events:none).
         */
        .ss-wm-fixed {
          position: fixed;
          top: 0;
          left: 0;
          width: 210mm;
          height: 100%;
          pointer-events: none;
          z-index: 111;
          background-image: url("${wmSvg}");
          background-repeat: repeat-y;
          background-size: 210mm 297mm;
          background-position: top left;
        }

        /* Hide watermark on screen — show only when printing */
        @media screen {
          .ss-wm-fixed {
            display: none;
          }
        }

        /*
         * SCREEN WATERMARK — absolute on the wrapper, tiles via repeat-y
         * Only shown on screen, hidden during print (print uses fixed above)
         */
        .ss-wm-screen {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: 111;
          background-image: url("${wmSvg}");
          background-repeat: repeat-y;
          background-size: 210mm 297mm;
          background-position: top left;
        }

        @media print {
          .ss-wm-screen {
            display: none;
          }
        }

        .ss-body {
          position: relative;
          z-index: 1;
          padding: 10mm 12mm 14mm;
          background: transparent;
        }
      `}</style>

      {/* Screen watermark — tiles over actual content height on screen */}
      <div className="ss-wm-screen" />

      {/*
        Print watermark — position:fixed means the print engine stamps it
        on every page of the document, no matter how many pages there are.
      */}
      <div className="ss-wm-fixed" />

      {/* ── CONTENT BODY ── */}
      <div className="ss-body">
        {/* Title */}
        <div
          style={{
            textAlign: "center",
            fontSize: "16px",
            fontWeight: 700,
            textDecoration: "underline",
            marginBottom: "12px",
          }}
        >
          {props?.currentWarehouseName ? "SUMMARY" : "MASTER SUMMARY"}
        </div>

        {props?.currentWarehouseName && (
          <div
            style={{
              textAlign: "center",
              fontSize: "12px",
              marginBottom: "10px",
            }}
          >
            Warehouse: <strong>{props.currentWarehouseName}</strong>
          </div>
        )}

        {/* Info header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: "12px",
            fontSize: "11.5px",
          }}
        >
          <div>
            <div
              style={{ fontWeight: 700, fontSize: "13px", marginBottom: "3px" }}
            >
              {OrderDetails?.name || OrderDetails?.dealerName}
              {OrderDetails?.storeName ? ` / ${OrderDetails.storeName}` : ""}
            </div>
            <div style={{ color: "#000", lineHeight: 1.5 }}>{Address}</div>
          </div>
          <div style={{ textAlign: "right", lineHeight: 1.9, color: "#000" }}>
            <div>
              Date &amp; Time:{" "}
              <strong>{formatDateTime(OrderDetails?.orderDate)}</strong>
            </div>
            <div>
              Order ID: <strong>{OrderDetails?.orderId || "—"}</strong>
            </div>
            <div>
              Payment Status:{" "}
              <strong style={{ color: statusColor }}>
                {OrderDetails?.paymentStatus || "—"}
              </strong>
            </div>
          </div>
        </div>

        {/* Main table */}
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            tableLayout: "fixed",
            fontSize: "11.5px",
          }}
        >
          <colgroup>
            <col style={{ width: COL.sno }} />
            <col style={{ width: COL.name }} />
            <col style={{ width: COL.item }} />
            <col style={{ width: COL.desc }} />
            <col style={{ width: COL.qty }} />
            <col style={{ width: COL.wh }} />
          </colgroup>
          <thead>
            <tr>
              <td style={S.th}>S.No</td>
              <td style={S.th}>Collection Name</td>
              <td style={S.th}>Item No.</td>
              <td style={S.th}>Description</td>
              <td style={S.th}>Qty</td>
              <td style={S.th}>Warehouse</td>
            </tr>
          </thead>
          <tbody>
            {categoryData.map((cat, ci) => {
              const catQty = cat.items.reduce(
                (s, i) => s + (Number(i?.qty) || 0),
                0,
              );
              const catVm = cat.items.reduce(
                (s, i) => s + (Number(i?.vm) || 0) * (Number(i?.qty) || 0),
                0,
              );
              const catWeight = cat.items.reduce(
                (s, i) => s + (Number(i?.weight) || 0) * (Number(i?.qty) || 0),
                0,
              );
              return (
                <React.Fragment key={ci}>
                  <tr>
                    <td colSpan={6} style={S.catHdr}>
                      {ci + 1}&nbsp;&nbsp;&nbsp;{cat.name}
                    </td>
                  </tr>
                  {cat.items.map((item, idx) => (
                    <tr key={idx} style={{ verticalAlign: "top" }}>
                      <td
                        style={{
                          ...S.item,
                          textAlign: "center",
                          fontSize: "11px",
                          verticalAlign: "top",
                        }}
                      >
                        {idx + 1}
                      </td>
                      <td style={{ ...S.item, verticalAlign: "top" }}>
                        <em>{cat.name}</em>
                      </td>
                      <td style={{ ...S.item, verticalAlign: "top" }}>
                        {item?.itemNo || ""}
                      </td>
                      <td style={S.itemDesc}>
                        {item?.desc || (
                          <span style={{ fontStyle: "normal" }}></span>
                        )}
                      </td>
                      <td style={{ ...S.item, verticalAlign: "top" }}>
                        {item?.qty || 0} {item?.unit || ""}
                      </td>
                      <td style={{ ...S.item, verticalAlign: "top" }}>
                        {item?.warehouse || ""}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={2} style={S.total}>
                      <strong>TOTAL</strong>
                    </td>
                    <td style={S.total}>
                      CBM : <strong>{catVm.toFixed(3)}</strong>
                    </td>
                    <td style={S.total}>
                      Weight : <strong>{catWeight.toFixed(3)} Kg</strong>
                    </td>
                    <td style={S.total}>
                      Qty : <strong>{catQty}</strong>
                    </td>
                    <td style={S.total}></td>
                  </tr>
                </React.Fragment>
              );
            })}
            <tr>
              <td colSpan={2} style={S.total}>
                <strong>GRAND TOTAL</strong>
              </td>
              <td style={S.total}>
                CBM : <strong>{grandTotals.vm.toFixed(3)}</strong>
              </td>
              <td style={S.total}>
                Weight : <strong>{grandTotals.weight.toFixed(3)} Kg</strong>
              </td>
              <td style={S.total}>
                Qty : <strong>{grandTotals.qty}</strong>
              </td>
              <td style={S.total}></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
});

export default NewSummarySlip;
